import React, { Fragment, FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Player, TeamGameMatch, TeamGameMatchTeam } from '../../../../../database.schema';
import * as CSS from '../../match-entry-styles';
import { FlexRowSpaceEvenly, Button } from '../../../common-styles/common-styles';

type SinglesDisplayProps = {
  selectedTournamentIndex: number;
  players: Array<Player>;
  matchIndex: number;
  match: TeamGameMatch;
};

export const SinglesDisplay: FC<SinglesDisplayProps> = ({ match, selectedTournamentIndex, players, matchIndex }): JSX.Element => {
  const navigate = useNavigate();

  const scoresEntered = (playerId: number): boolean => {
    return match.teams[0].players.find((player) => player.playerId === playerId)?.round.individualHandicap !== -1;
  };

  return (
    <Fragment>
      {match.matchPlayMatches?.map((singleMatch, singlesIndex: number) => (
        <CSS.MatchWrapper key={`stored-match-${singlesIndex}`} data-testid="match-wrapper">
          <h3>{`Singles Match ${singlesIndex + 1}`}</h3>
          <FlexRowSpaceEvenly>
            <CSS.CreatedMatch data-testid={`team-1-${singlesIndex}`} bgColour={'red'}>
              <div>
                {singleMatch.team1.playerIds.map((playerId: number, playerIndex) => (
                  <div data-testid={`team-1-${singlesIndex}-player-${playerIndex}`} key={`team-1-player-${playerId}`}>
                    {players.find((player1: Player) => player1.id === playerId)?.nickName}
                  </div>
                ))}
              </div>
            </CSS.CreatedMatch>
            V
            <CSS.CreatedMatch data-testid={`team-2-${singlesIndex}`} bgColour={'blue'}>
              <div>
                {singleMatch.team2.playerIds.map((playerId: number, playerIndex) => (
                  <div data-testid={`team-2-${singlesIndex}-player-${playerIndex}`} key={`team-2-player-${playerId}`}>
                    {players.find((player1: Player) => player1.id === playerId)?.nickName}
                  </div>
                ))}
              </div>
            </CSS.CreatedMatch>
          </FlexRowSpaceEvenly>
          <Button
            data-testid={`enter-scores-${singlesIndex}`}
            onClick={() => {
              navigate(`/${scoresEntered(singleMatch.team1.playerIds[0]) ? 'edit' : 'add'}-team-game-matchplay-scorecard/${selectedTournamentIndex}/${matchIndex}/${singlesIndex}`);
            }}
          >
            {scoresEntered(singleMatch.team1.playerIds[0]) ? 'Edit scores' : 'Add scores'}
          </Button>
        </CSS.MatchWrapper>
      ))}
    </Fragment>
  );
};
